import { Component, ElementRef, Inject, LOCALE_ID, OnInit, PLATFORM_ID, Renderer2, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';
import { takeUntil } from 'rxjs';
import { Page } from 'src/app/apollo/models/base-models';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { DesktopService } from 'src/app/services/desktop/desktop.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { environment } from 'src/environments/environment';
import { BasePageComponent } from '../../base-page/base-page.component';
import { loadChatScript } from 'src/app/utils/load-chat';
import { isPlatformBrowser } from '@angular/common';
import { AdformTrackingPage, AdformTrackingService } from 'src/app/services/tracking/adform-tracking.service';
import { HOST_NAME, LICENCE } from "src/app/global.tokens";
import { LicenceService } from 'src/app/services/utils/licence.service';
import { StaticPageComponent } from '../../static-page/static-page.component';
import { ClonerService } from 'src/app/services/utils/clone-object.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { depositTrx, paymentTrx, promotionsTrx } from 'src/app/router-translation.labels';

@Component({
  selector: 'app-static-content',
  templateUrl: './static-content.component.html',
  styleUrls: ['./static-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StaticContentComponent extends BasePageComponent implements OnInit {
  pageHtml: any;
  routePath: any;
  isHtml: boolean = false;
  pageJson: Page;
  paymentUrl: string[] = [`/${this.translationConfig.getTranslation(paymentTrx)}`, this.translationConfig.getTranslation(depositTrx)];
  promotionsTrx: string[] = [`/${this.translationConfig.getTranslation(promotionsTrx)}`];
  isVipPage: boolean = false;

  constructor(
    private desktopService: DesktopService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    public loginStatusService: LoginStatusService,
    public detectDeviceService: DetectDeviceService,
    private adformService: AdformTrackingService,
    public licenceConfigService: LicenceService,
    private cloneService: ClonerService,
    protected translationConfig: TranslationConfig,
    @Inject(PLATFORM_ID) public platfromId: string,
    @Inject(WINDOW) readonly windowRef: Window,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public license: string,
    @Inject(HOST_NAME) public hostname: string,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    super();
  }

  replaceTemplateTags(content) {
    return content?.replaceAll("{CasinoName}", this.licenceConfigService.getKey("name")).replaceAll("{Hostname}", this.hostname).replaceAll("{OriginalDomain}", this.licenceConfigService.getKey("originalDomain"))
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platfromId)) {
      setTimeout(() => {
        this.setupCardFlip();
      }, 1000);
    }
  }


  ngOnInit(): void {
    this.adformService.setTrackingPage(AdformTrackingPage.ALL_PAGES);
    this.route.data.subscribe(res => {
      if (res.hasOwnProperty('tabIndex')) {        // tabIndex defined in desktop route config only for support/faq/self-exclusion tabs
        this.tabContent();
      } else {
        const page = res.info.data.pages.filter((p) => p.license === this.license)[0];
        this.pageJson = this.cloneService.deepClone(page ? page : res.info.data.pages[0]);

        this.prepareContent(this.pageJson);
      }
      if (this.route.snapshot.url.toString().includes('support')) {
        if (isPlatformBrowser(this.platfromId)) {
          this.loginStatusService.getIfUserLogged().pipe(takeUntil(this.unsubscribe)).subscribe((status) => {
            loadChatScript(this.locale, status.username, status.fullInfo.first_name);
            console.log("chat enabled")
          });
        }
      }
      if (this.route.snapshot.url.toString().includes('support')) {
        if (isPlatformBrowser(this.platfromId)) {
          this.loginStatusService.getIfUserLogged().pipe(takeUntil(this.unsubscribe)).subscribe((status) => {
            let roles = status.fullInfo?.roles?.map((item: string) => item.toLowerCase());
            const hasVip = !!roles.find((item: string) => item.includes('vip')) || !!roles.some((item: string) => ["EX_VIP_ROW", "EX_VIP_PL", "EX_SVIP_ROW", "EX_SVIP_PL"].includes(item.toUpperCase()));

            if (hasVip) {
              loadChatScript(`vip-${this.locale}`, status.username, status.fullInfo.first_name);
            } else {
              loadChatScript(this.locale, status.username, status.fullInfo.first_name);
            }
            console.log("chat enabled 1")
          });
        }
      }
    })
    this.isDesktop = this.detectDeviceService.isDesktop();
  }

  prepareContent(pageJson: Page) {
    this.isVipPage = ['vip-club'].includes(pageJson.name)
    pageJson.displayName = this.replaceTemplateTags(pageJson.displayName)
    pageJson.title = this.replaceTemplateTags(pageJson.title)
    pageJson.description = this.replaceTemplateTags(pageJson.description)
    const title = !!pageJson.seo?.metaTitle ? this.replaceTemplateTags(pageJson.seo.metaTitle) : `${this.replaceTemplateTags(pageJson.displayName)} | ${this.licenceConfigService.getKey("name")}`;
    const description = !!pageJson.seo?.metaDescription
      ? this.replaceTemplateTags(pageJson.seo.metaDescription)
      : $localize`:@@description-static-page: Read to know more about ${pageJson.displayName} at ${this.licenceConfigService.getKey("name")} in "year". Register today to get your welcome bonus, play and win more with ${this.licenceConfigService.getKey("name")}.`;
    this.setSEOTags(title, description, pageJson.seo?.relCanonical, null, pageJson.seo?.noIndex);
    if (pageJson?.pageType === "html") {
      this.isHtml = true;
      let pageContent = pageJson.htmlContent.replace("{{content}}", pageJson.content?.html);
      pageJson.pageAdditionalContents.forEach((item) => {
        pageContent = this.replaceTemplateTags(pageContent.replace(`{{${item.name}}}`, item.content.html));
      })
      this.pageHtml = this.sanitizer.bypassSecurityTrustHtml(pageContent)
    }
    else {
      this.isHtml = false;
      this.pageHtml = this.sanitizer.bypassSecurityTrustHtml(this.replaceTemplateTags(pageJson?.content?.html));

    }
  }

  tabContent() {      // Invoke only for support/faq/self-exclusion tabs
    this.desktopService.staticData('info', this.data).valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      console.log("support res", res)
      const pageJson = this.cloneService.deepClone<Page>(res.data.pages.filter(item => !!item.licenceNew?.find(licence => licence === this.license))[0] || res.data.pages[0]);
      this.pageJson = pageJson;

      const title = !!pageJson.seo?.metaTitle ? this.replaceTemplateTags(pageJson.seo.metaTitle) : `${this.replaceTemplateTags(pageJson.displayName)} | ${this.licenceConfigService.getKey("name")}`;

      const description = !!pageJson.seo?.metaDescription
        ? this.replaceTemplateTags(pageJson.seo.metaDescription)
        : $localize`:@@description-static-page: Read to know more about ${pageJson.displayName} at ${this.licenceConfigService.getKey("name")} in "year". Register today to get your welcome bonus, play and win more with ${this.licenceConfigService.getKey("name")}.`;
      this.setSEOTags(title, description);
      this.prepareContent(pageJson);
      this.router.navigateByUrl('info/' + this.data);
    })
  }

  redirectPayment() {
    if (this.pageJson.bonuses.length > 0) {
      this.router.navigate(this.paymentUrl, { state: { bonus: this.pageJson.bonuses[0]?.externalId } });
    }
    else {
      this.router.navigate(this.paymentUrl);
    }
  }

  setupCardFlip() {
    const cards = this.el.nativeElement.querySelectorAll(".card-inner");
    const flipContent = this.el.nativeElement.querySelectorAll(".flip-content");

    flipContent.forEach((cont: HTMLElement)=>{
      cont.textContent = 'Hover to flip';
    })

    cards.forEach((card: HTMLElement) => {
      this.renderer.listen(card, "mouseenter", () => {
        cards.forEach((otherCard: HTMLElement) => {
          if (otherCard !== card) {
            this.renderer.removeClass(otherCard, "is-flipped");
          }
        });
        if (card.classList.contains("is-flipped")) {
          this.renderer.removeClass(card, "is-flipped");
        } else {
          this.renderer.addClass(card, "is-flipped");
        }

      });
    });
  }
}
